/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import loggedInCheckinStyle from "./loggedInCheckinStyle";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import CheckmarkIcon from "@mui/icons-material/DoneRounded";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

type LoggedInCheckinProps = {
  bullet1: string;
  bullet2: string;
  bullet3: string;
  buttonLink: string;
  buttonText?: string;
  checkinHeading: string;
  color?: "default" | "grey";
  idPrefix: string;
  withAdvantages?: boolean;
};

const LoggedInCheckin = ({
  idPrefix,
  checkinHeading,
  color = "default",
  buttonText = "Jetzt kostenlos starten",
  buttonLink,
  bullet1,
  bullet2,
  bullet3,
  withAdvantages = true,
}: LoggedInCheckinProps) => {
  return (
    <Paper elevation={4} sx={{ ...loggedInCheckinStyle.formPaper, ...loggedInCheckinStyle[color] }}>
      <Box id={idPrefix + "-checkin"} sx={loggedInCheckinStyle.scrollToAnchor} />
      <Typography variant={"h4"} sx={loggedInCheckinStyle.heading}>
        {checkinHeading}
      </Typography>
      <Grid container alignItems={"baseline"} justifyContent={"center"}>
        <Grid item md={6} xs={12}>
          <Button component={Link} to={buttonLink} variant="contained" color="primary" sx={loggedInCheckinStyle.button} fullWidth>
            {buttonText}
          </Button>
        </Grid>
      </Grid>

      {withAdvantages && (
        <Grid container>
          <Grid item xs={12}>
            <Grid container sx={loggedInCheckinStyle.advantagesGridContainer}>
              <Grid item sm={6} xs={12} md={4} sx={loggedInCheckinStyle.advantagesGridItems}>
                <Box sx={loggedInCheckinStyle.advantagesContainer}>
                  <CheckmarkIcon sx={loggedInCheckinStyle.checkmark} />
                  <Box component={"span"} sx={loggedInCheckinStyle.advantages}>
                    {bullet1}
                  </Box>
                </Box>
              </Grid>
              <Grid item sm={6} xs={12} md={4} sx={loggedInCheckinStyle.advantagesGridItems}>
                <Box sx={loggedInCheckinStyle.advantagesContainer}>
                  <CheckmarkIcon sx={loggedInCheckinStyle.checkmark} />
                  <Box component={"span"} sx={loggedInCheckinStyle.advantages}>
                    {bullet2}
                  </Box>
                </Box>
              </Grid>
              <Grid item sm={6} xs={12} md={4} sx={loggedInCheckinStyle.advantagesGridItems}>
                <Box sx={loggedInCheckinStyle.advantagesContainer}>
                  <CheckmarkIcon sx={loggedInCheckinStyle.checkmark} />
                  <Box component={"span"} sx={loggedInCheckinStyle.advantages}>
                    {bullet3}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Paper>
  );
};

export default LoggedInCheckin;
